import {
  Button,
  Flex,
  Table,
  Tbody,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  useDisclosure,
} from "@chakra-ui/react";
import useAxios from "axios-hooks";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import ApiKeyRow from "components/ApiKey/ApiKeyRow";
import ApiKeyAddDialog from "components/ApiKey/ApiKeyAddDialog";
import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { checkLogin, getToken } from "../../../utils/authentication";
import { API_ROUTES } from "utils/constant";

function ApiKey() {
  const history = useHistory();
  const textColor = useColorModeValue("gray.700", "white");
  const borderColor = useColorModeValue("gray.200", "gray.600");
  const xToken = getToken();
  const isLoggedIn = checkLogin();

  const { isOpen: isAddOpen, onOpen: onAddOpen, onClose: onAddClose } =
    useDisclosure();

  const [{ data, loading }, refetch] = useAxios({
    url: API_ROUTES.ApiKeyList,
    headers: { xToken },
  });

  useEffect(() => {
    if (!isLoggedIn) history.push("/auth/signin");
  }, [isLoggedIn, history]);

  const items = data?.data || [];

  return (
    <>
      <Flex direction="column" pt={{ base: "120px", md: "75px" }}>
        <Card bg="#fff" overflowX={{ sm: "scroll", xl: "hidden" }} pb="0px">
          <CardHeader p="6px 0px 22px 0px">
            <Text fontSize="xl" color={textColor} fontWeight="bold">
              API Keys
            </Text>
            <Button variant="primary" maxH="30px" m="10px" onClick={onAddOpen}>
              Tạo API Key
            </Button>
          </CardHeader>
          <CardBody>
            <Table variant="simple" color={textColor}>
              <Thead>
                <Tr my=".8rem" pl="0px" color="gray.400">
                  <Th pl="0px" borderColor={borderColor} color="gray.400">
                    Brand
                  </Th>
                  <Th borderColor={borderColor} color="gray.400">
                    Key
                  </Th>
                  <Th borderColor={borderColor} color="gray.400">
                    Ghi chú
                  </Th>
                  <Th borderColor={borderColor} color="gray.400">
                    Trạng thái
                  </Th>
                  <Th borderColor={borderColor} color="gray.400">
                    Lượt dùng
                  </Th>
                  <Th borderColor={borderColor} color="gray.400">
                    Tạo lúc
                  </Th>
                  <Th borderColor={borderColor} color="gray.400"></Th>
                </Tr>
              </Thead>
              <Tbody>
                {items.map((row, index, arr) => (
                  <ApiKeyRow
                    key={row._id}
                    detail={row}
                    isLast={index === arr.length - 1}
                    refetch={refetch}
                  />
                ))}
              </Tbody>
            </Table>
          </CardBody>
        </Card>
      </Flex>
      {isAddOpen && (
        <ApiKeyAddDialog
          isOpen={isAddOpen}
          onClose={onAddClose}
          refetch={refetch}
        />
      )}
    </>
  );
}

export default ApiKey;
